import { WidgetSimulatorType } from '../../../../types/widget';
import GrossNetSalarySVG from '../simulators/svgs/GrossNetSalarySVG';
import IntracommunityVatSVG from '../simulators/svgs/IntracommunityVatSVG';
import KilometricExpensesSVG from '../simulators/svgs/KilometricExpensesSVG';
import LoanSimulationSVG from '../simulators/svgs/LoanSimulationSVG';
import MarginCoefficientSVG from '../simulators/svgs/MarginCoefficientSVG';
import VatTtcHtSVG from '../simulators/svgs/VatTtcHtSVG';
import { SimulatorDetailsType } from '../types/simulator';

const simulatorTypeDetailsMapper = new Map<string, Pick<SimulatorDetailsType, 'url' | 'icon' | 'backgroundColor'>>([
	[
		'gross-net-salary',
		{
			url: 'https://code.travail.gouv.fr/outils/simulateur-embauche',
			icon: <GrossNetSalarySVG />,
			backgroundColor: '#B873AB',
		},
	],
	[
		'intracommunity-vat',
		{
			url: 'https://annuaire-entreprises.data.gouv.fr/',
			icon: <IntracommunityVatSVG />,
			backgroundColor: '#039BE5',
		},
	],
	[
		'Kilometric-expenses',
		{
			url: 'https://www.impots.gouv.fr/simulateur-bareme-kilometrique',
			icon: <KilometricExpensesSVG />,
			backgroundColor: '#FF7F50',
		},
	],
	[
		'loan-simulation',
		{
			url: 'https://www.lafinancepourtous.com/outils/calculateurs/calculateur-de-credit-immobilier/',
			icon: <LoanSimulationSVG />,
			backgroundColor: '#228B22',
		},
	],
	[
		'margin-coefficient',
		{
			url: 'https://bgepro.bge.asso.fr/simulateur/CoefEtMarge.aspx',
			icon: <MarginCoefficientSVG />,
			backgroundColor: '#FFA500',
		},
	],
	[
		'vat-ttc-ht',
		{
			url: 'https://entreprendre.service-public.fr/simulateur/calcul/convertisseurPrixHTouTTC',
			icon: <VatTtcHtSVG />,
			backgroundColor: '#002B66',
		},
	],
]);

export const getSimulatorDetails = ({ simulator }: { simulator: WidgetSimulatorType }) => {
	const { name, type = 'generic' } = simulator;

	return {
		...(simulatorTypeDetailsMapper.get(type) ?? {}),
		name,
	};
};
